import {AbstractAPIPlatformProvider} from './abstract';
import {Preference as PreferenceModel} from '../model';
import {PROVIDER} from '../../../resources/bcmApi';

export class Preference extends AbstractAPIPlatformProvider {
  name = PROVIDER.PREFERENCES;
  model = new PreferenceModel();
}
